import React from "react";

export const BackIcon = (props) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={props.onClick}
      >
        <path
          d="M17.3333 7.91634H4.14917L10.205 1.86051L8.66667 0.333008L0 8.99967L8.66667 17.6663L10.1942 16.1388L4.14917 10.083H17.3333V7.91634Z"
          fill="#383838"
          style={{
            fill: "#383838",
            fill: "color(display-p3 0.2180 0.2180 0.2180)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
